import { useQuery } from 'react-query';
import { dsoCheckoutService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useRetrieveDsoBillingAddressesByShipAccount = (
  shipAccountNumber: string | undefined
) => {
  return useQuery(
    [ServerStateKeysEnum.dsoBillingAddressesByShipAccount, shipAccountNumber],
    () =>
      dsoCheckoutService.getBillingAddressesByShipAccount(shipAccountNumber!),
    {
      staleTime: Infinity,
      enabled: !!shipAccountNumber,
    }
  );
};
